import axios, { type InternalAxiosRequestConfig } from "axios";

const superAdminApi = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

superAdminApi.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const fallback = localStorage.getItem("sa_fallbackToken");
  if (fallback && config && !config.headers?.Authorization) {
    config.headers.Authorization = `Bearer ${fallback}`;
  }
  return config;
});

export default superAdminApi;
